import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ButtonLoader from 'LIBRARY/CommonResources/ButtonLoader/ButtonLoader';
import SuccessModal from 'LIBRARY/CommonResources/SuccessModal/SuccessModal';
import LibraryApiCall from 'LibraryApiCall';
import config from 'config';
import React, { Component } from 'react';
import Pagination from 'react-js-pagination';
import 'LIBRARY/Components/PrintBarcode/ManageTemplate/managetemplate.css';
import 'LIBRARY/Components/PrintBarcode/PrintBarcode.css';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import ReactHtmlParser from 'react-html-parser';
// import { Editor } from '@tinymce/tinymce-react';
import Editor from "ckeditor4-react";
import DeleteModal from 'LIBRARY/CommonResources/DeleteModal/DeleteModal';
import Spinner from 'LIBRARY/CommonResources/SpinnerLoader/Spinner';
import ReactToPrint from 'react-to-print';
import { Base64 } from 'js-base64';
import DeleteTextModal from 'LIBRARY/CommonResources/DeleteTextModal/DeleteTextModal';
import axios from 'axios';
import { connect } from 'react-redux';
import FroalaEditor from 'react-froala-wysiwyg';

// Import Froala Editor CSS and JS files

import 'froala-editor/css/froala_editor.pkgd.min.css';
import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/css/themes/dark.min.css';
import 'froala-editor/js/froala_editor.pkgd.min.js';
import 'froala-editor/js/plugins/align.min.js';
import 'froala-editor/js/plugins/code_beautifier.min.js';
import 'froala-editor/js/plugins/code_view.min.js';
import 'froala-editor/js/plugins/colors.min.js';
import 'froala-editor/js/plugins/draggable.min.js';
import 'froala-editor/js/plugins/emoticons.min.js';
import 'froala-editor/js/plugins/font_size.min.js';
import 'froala-editor/js/plugins/fullscreen.min.js';
import 'froala-editor/js/plugins/image.min.js';
import 'froala-editor/js/plugins/link.min.js';
import 'froala-editor/js/plugins/lists.min.js';
import 'froala-editor/js/plugins/paragraph_format.min.js';
import 'froala-editor/js/plugins/paragraph_style.min.js';
import 'froala-editor/js/plugins/quick_insert.min.js';
import 'froala-editor/js/plugins/table.min.js'; // Import table plugin
import 'froala-editor/js/plugins/url.min.js';
import 'froala-editor/js/plugins/word_paste.min.js';
import SpecificUserLog from 'LIBRARY/CommonResources/SpecificUserLog/SpecificUserLog';

let apiPath = "/api/library/barcodeTemplate.php";

class ManageTemplate extends Component {

    constructor(props) {
        super(props);
        this.editorRef = React.createRef(null);
        this.state = {
            form: this.props.form,
            addTemplate: false,
            deleteModal: false,

            isTemplateEditMode: false,
            disableButton: false,
            templateList: {},
            total: 0,
            templateListFetching: false,
            offset: 0,

            templateName: '',
            templateNameWarning: '',
            customHeight: '',
            customHeightWarning: '',
            customWidth: '',
            customWidthWarning: '',
            barcodeHeight: '',
            barcodeWidth: '',
            pageWidth: '',
            pageHeight: '',
            verticalGap: '',
            horizontalGap: '',
            configurationObject: {},
            templateId: '',

            froala_auth_key: "",
            froalaKeyAvailable: false,

            showActivitySlider: false,
            selectedIid:"",
            hoverID:""
        };
    }

    componentDidMount() {

        // METHOD TO GET BARCODE TEMPLATE LIST
        this.apiCallToGetTemplateList();
        
        this.getfroalaKey();
    }

    // API METHOD TO GET TEMPLATE LIST
    getfroalaKey = async () => {

        let jsonResponse = await LibraryApiCall.makeApiCall(
            "getfroalaKey",
            {},
            "/api/idCard/idcard.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getfroalaKey();
            }, 1000);
        } else {
            if (jsonResponse.success) {

                this.setState({
                    froala_auth_key: jsonResponse.APIResult.froala_auth_key,
                    froalaKeyAvailable: true
                });
            } else {
                this.setState({
                    animating: false,
                    successModal: true,
                    successModalType: "error",
                    successMessage:
                        "Something went wrong while getting template  list. Please try again later.",
                });
            }
        }
    };

    //API CALL METHOD TO GET TEMPLATE LIST
    apiCallToGetTemplateList = async () => {
        this.setState({
            templateListFetching: true
        });

        let requestData = {
            "institute_id": config.institute_id,
            "page_index": '',
            "limit": ''
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getBarcodeTemplateList',
            requestData,
            apiPath
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetTemplateList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                this.setState({
                    templateList: apiResult,
                    templateListFetching: false,
                    total: jsonResponse.APIResult.total
                });
            } else {
                this.setState({
                    templateListFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting template data. Please try again later.'
                });
            }
        }
    }

    // METHOD TO VALIDATE TEMPLATE DATA
    validateTemplateDetails = () => {
        let validData = true;
        let configuration = this.state.configurationObject;

        if (this.state.templateName == '') {
            this.setState({
                templateNameWarning: 'Template name cannot be empty.'
            });
            validData = false;
        }

        if (this.state.customHeight == '') {
            this.setState({
                customHeightWarning: 'Barcode height cannot be empty.'
            });
            validData = false;
        }

        if (this.state.customWidth == '') {
            this.setState({
                customWidthWarning: 'Barcode width cannot be empty.'
            });
            validData = false;
        }

        if (validData) {

            configuration['size'] = this.state.barcodeSize;
            configuration['height'] = this.state.customHeight;
            configuration['width'] = this.state.customWidth;
            configuration['barcodeHeight'] = this.state.barcodeHeight;
            configuration['barcodeWidth'] = this.state.barcodeWidth;
            configuration['horizontalGap'] = this.state.horizontalGap;
            configuration['verticalGap'] = this.state.verticalGap;
            configuration['pageHeight'] = this.state.pageHeight;
            configuration['pageWidth'] = this.state.pageWidth;

            this.setState({
                configurationObject: configuration
            });

            if (this.state.isTemplateEditMode) {
                this.apiCallToUpdateTemplate();
            } else {
                this.apiCallToAddTemplate();
            }
        }
    }

    // API CALL METHOD TO ADD FORM
    apiCallToAddTemplate = async () => {
        this.setState({
            disableButton: true
        });

        let requestData = {
            "institute_id": config.institute_id,
            "added_by": config.faculty_id,
            "template_name": this.state.templateName,
            "template_configuration": this.state.configurationObject,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'addBarcodeTemplate',
            requestData,
            apiPath
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToAddTemplate()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                let templateList = this.state.templateList;

                if (apiResult.status == 'success') {
                    if (templateList[apiResult.UID] == undefined) {
                        templateList[apiResult.UID] = {};
                    }

                    templateList[apiResult.UID]['templateName'] = this.state.templateName;
                    templateList[apiResult.UID]['configuration'] = this.state.configurationObject;
                    this.setState({
                        successModal: true,
                        successModalType: 'success',
                        successMessage: ReactHtmlParser(apiResult.message),
                        disableButton: false,
                        templateList
                    });
                    this.closeAddTemplate();
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message,
                        disableButton: false
                    });
                    this.closeAddTemplate();
                }
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while adding template data. Please try again later.',
                    disableButton: false
                });
                this.closeAddTemplate();
            }
        }
    }

    // API CALL METHOD TO UPDATE FORM
    apiCallToUpdateTemplate = async () => {
        this.setState({
            disableButton: true
        });

        let requestData = {
            "institute_id": config.institute_id,
            "updated_by": config.faculty_id,
            "template_name": this.state.templateName,
            "template_configuration": this.state.configurationObject,
            'template_id': this.state.templateId,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'updateBarcodeTemplate',
            requestData,
            apiPath
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToUpdateTemplate()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                let templateList = this.state.templateList;
                if (apiResult.status == 'success') {
                    templateList[this.state.templateId]['templateName'] = this.state.templateName;
                    templateList[this.state.templateId]['configuration'] = this.state.configurationObject;
                    this.setState({
                        successModal: true,
                        successModalType: 'success',
                        successMessage: ReactHtmlParser(apiResult.message),
                        disableButton: false
                    });
                    this.closeAddTemplate();
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message,
                        disableButton: false
                    });
                    this.closeAddTemplate();
                }
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while updating form. Please try again later.',
                    disableButton: false
                });
                this.closeAddTemplate();
            }
        }
    }

    // METHOD TO GET PAGE HEIGHT
    getPageHeight = (e) => {
        this.setState({
            pageHeight: e.target.value
        });
    }

    // METHOD TO GET HORIZONTAL GAP
    getHorizontalGap = (e) => {
        this.setState({
            horizontalGap: e.target.value
        });
    }

    // METHOD TO GET VERTICAL GAP
    getVerticalGap = (e) => {
        this.setState({
            verticalGap: e.target.value
        });
    }

    // METHOD TO GET PAGE WIDTH
    getPageWidth = (e) => {
        this.setState({
            pageWidth: e.target.value
        });
    }

    // METHOD TO RETURN ADD TEMPLATE MODAL
    returnAddTemplateModal = () => {
        return (
            <div className={this.state.addTemplate ? "modal fade show" : "modal fade"} id="modalContainer" >
                <div className="modal-dialog modal-dialog-centered modal-xl" >
                    <div className="modal-content" style={{ height: "calc(100vh - 50px)" }}>
                        <div className="modal-header">
                            <div>
                                {this.state.isTemplateEditMode ? 'Update Barcode Template' : 'Add Barcode Template'}
                            </div>
                            <FontAwesomeIcon icon={['fas', 'times']} style={{ cursor: 'pointer' }} size="lg" color="white" onClick={() => this.closeAddTemplate()} />
                        </div>
                        <div className="modal-body addTemplateBody">
                            <div className="templateForm">
                                <div className="col-md-12 templateDetails" style={{ display: 'flex', padding: 0 }}>
                                    <div className="col-md-12 templateName">
                                        <label style={{ fontWeight: 'bold', fontSize: 14, marginBottom: 0 }}>Template Name <span style={{ color: 'red' }}>*</span></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={this.state.templateName}
                                            placeholder="Enter Template Name"
                                            maxLength={250}
                                            onChange={(e) => this.getTemplateName(e)}
                                        />
                                        <p style={{ display: this.state.templateNameWarning.length > 0 ? 'block' : 'none', color: 'red', fontSize: 14 }}>{this.state.templateNameWarning}</p>
                                    </div>
                                </div>
                                <div className='col-md-12 templateDetails' style={{ display: 'flex', padding: 0, justifyContent: 'flex-end' }}>
                                    <div className="col-md-3 templateWidth">
                                        <label style={{ fontWeight: 'bold', fontSize: 14, textTransform: 'none', marginBottom: 0 }}>Sticker Width in mm (Millimeter) <span style={{ color: 'red' }}>*</span></label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            value={this.state.customWidth}
                                            placeholder="Enter width in mm"
                                            maxLength={250}
                                            onChange={(e) => this.getCustomWidth(e)}
                                        />
                                        <p style={{ display: this.state.customWidthWarning.length > 0 ? 'block' : 'none', color: 'red', fontSize: 14 }}>{this.state.customWidthWarning}</p>
                                    </div>
                                    <div className="col-md-3 templateWidth">
                                        <label style={{ fontWeight: 'bold', fontSize: 14, textTransform: 'none', marginBottom: 0 }}>Barcode Width in % (Percentage) <span style={{ color: 'red' }}>*</span></label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            value={this.state.barcodeWidth}
                                            placeholder="Enter barcode width in %"
                                            maxLength={250}
                                            onChange={(e) => this.getBarcodeWidth(e)}
                                        />
                                        <p style={{ display: this.state.customWidthWarning.length > 0 ? 'block' : 'none', color: 'red', fontSize: 14 }}>{this.state.customWidthWarning}</p>
                                    </div>
                                    <div className="col-md-3 templateHeight">
                                        <label style={{ fontWeight: 'bold', fontSize: 14, textTransform: 'none', marginBottom: 0 }}>Sticker Height in mm (Millimeter)<span style={{ color: 'red' }}>*</span></label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            value={this.state.customHeight}
                                            placeholder="Enter height in mm"
                                            maxLength={250}
                                            onChange={(e) => this.getCustomHeight(e)}
                                        />
                                        <p style={{ display: this.state.customHeightWarning.length > 0 ? 'block' : 'none', color: 'red', fontSize: 14 }}>{this.state.customHeightWarning}</p>
                                    </div>
                                    <div className="col-md-3 templateHeight">
                                        <label style={{ fontWeight: 'bold', fontSize: 14, textTransform: 'none', marginBottom: 0 }}>Barcode Height in % (Percentage)<span style={{ color: 'red' }}>*</span></label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            value={this.state.barcodeHeight}
                                            placeholder="Enter barcode height in %"
                                            maxLength={250}
                                            onChange={(e) => this.getBarcodeHeight(e)}
                                        />
                                        <p style={{ display: this.state.customHeightWarning.length > 0 ? 'block' : 'none', color: 'red', fontSize: 14 }}>{this.state.customHeightWarning}</p>
                                    </div>
                                </div>
                                <div className='col-md-12 templateDetails' style={{ display: 'flex', padding: 0, justifyContent: 'flex-end' }}>
                                    <div className="col-md-3 templateWidth">
                                        <label style={{ fontWeight: 'bold', fontSize: 14, textTransform: 'none', marginBottom: 0 }}>Horizontal Gap between stickers (in mm)</label>
                                        <input
                                            type="number"
                                            className="form-control printBarcodeInput"
                                            placeholder="Enter horizontal gap in mm"
                                            value={this.state.horizontalGap}
                                            onChange={(e) => this.getHorizontalGap(e)}
                                        />
                                    </div>
                                    <div className="col-md-3 templateWidth">
                                        <label style={{ fontWeight: 'bold', fontSize: 14, textTransform: 'none', marginBottom: 0 }}>Vertical Gap between stickers (in mm)</label>
                                        <input
                                            type="number"
                                            className="form-control printBarcodeInput"
                                            placeholder="Enter vertical gap in mm"
                                            value={this.state.verticalGap}
                                            onChange={(e) => this.getVerticalGap(e)}
                                        />
                                    </div>
                                    <div className="col-md-3 templateHeight">
                                        <label style={{ fontWeight: 'bold', fontSize: 14, textTransform: 'none', marginBottom: 0 }}>Page Height (in mm)</label>
                                        <input
                                            type="text"
                                            className="form-control printBarcodeInput"
                                            placeholder="Enter page height in mm"
                                            value={this.state.pageHeight}
                                            onChange={(e) => this.getPageHeight(e)}
                                        />
                                    </div>
                                    <div className="col-md-3 templateHeight">
                                        <label style={{ fontWeight: 'bold', fontSize: 14, textTransform: 'none', marginBottom: 0 }}>Page Width (in mm)</label>
                                        <input
                                            type="text"
                                            className="form-control printBarcodeInput"
                                            placeholder="Enter page width in mm"
                                            value={this.state.pageWidth}
                                            onChange={(e) => this.getPageWidth(e)}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-12 barcodeDesign" style={{ marginTop: '10px', padding: 0 }}>
                                    <span style={{ fontWeight: 'bold' }}>Design Barcode</span>
                                    {/* <Editor
                                        data={this.state.configurationObject['barcodeConfiguration']}
                                        config={{
                                            toolbar_Basic : [['Bold', 'Italic'], ['Table']],

                                            toolbar: [
                                                { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ], items: [ 'Bold', 'Italic', 'Underline' ] },
                                                { name: 'paragraph', groups: [ 'list' ], items: [ 'BulletedList' ] },
                                                { name: 'insert', items: [ 'Table' ] },
                                            ],
                                        }}
                                        
                                        onChange={(e) => this.getBarcodeConfiguration(e)}
                                    /> */}
                                    {
                                        this.state.froalaKeyAvailable &&
                                        <FroalaEditor
                                            model={this.state.configurationObject['barcodeConfiguration']}
                                            onModelChange={this.getBarcodeConfiguration}
                                            config={{
                                                height: 400,
                                                key: this.state.froala_auth_key,
                                                attribution: false, // Disable Froala attribution
                                                zIndex: 1,
                                                toolbarButtons: [
                                                    'undo', 'redo', '|', 'bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', '|',
                                                    'fontFamily', 'fontSize', 'color', '|', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', '|',
                                                    'insertLink', 'insertImage', 'insertVideo', 'insertFile', 'insertTable', '|', 'clearFormatting', '|', 'html',
                                                    '|', 'tableInsertRowAfter', 'tableInsertRowBefore', 'tableInsertColumnAfter', 'tableInsertColumnBefore',
                                                    'tableDeleteRow', 'tableDeleteColumn', 'textColor'
                                                ],
                                                pluginsEnabled: ['tooltips',
                                                    'align', 'codeBeautifier', 'codeView', 'colors', 'draggable', 'emoticons', 'fontSize', 'fullscreen',
                                                    'image', 'link', 'lists', 'paragraphFormat', 'paragraphStyle', 'quickInsert', 'table', 'url', 'wordPaste'
                                                ],
                                                placeholderText: 'Edit Your Content Here!',
                                                quickInsertTags: [''],

                                                charCounterCount: true,

                                            }}
                                        />
                                    }
                                </div>
                                <div class="col-md-12 barcodeParams" style={{ marginTop: 10, padding: 0 }}>
                                    <div class="col-md-5 barcodeParameters" style={{ textAlign: 'left', padding: 0 }}>
                                        <label title="Click here to add barcode" className="barcodeParameter" ><a id="add-button" onClick={(e) => this.addParameter(e, '{Barcode}')}>&nbsp;&nbsp;Barcode</a></label>&nbsp;
                                        <label title="Click here to add accession number" className="barcodeParameter" ><a id="add-button" onClick={(e) => this.addParameter(e, '{Accession_number}')}  >&nbsp;&nbsp;Accession_number</a></label>&nbsp;
                                        <label title="Click here to add accession series" className="barcodeParameter" ><a id="add-button" onClick={(e) => this.addParameter(e, '{Accession_series}')} >&nbsp;&nbsp;Accession_series</a></label>&nbsp;
                                        <label title="Click here to add call index" className="barcodeParameter" ><a id="add-button" onClick={(e) => this.addParameter(e, '{Call_Index}')}  >&nbsp;&nbsp;Call_Index</a></label>&nbsp;
                                        <label title="Click here to add call number" className="barcodeParameter" ><a id="add-button" onClick={(e) => this.addParameter(e, '{Call_Number}')} >&nbsp;&nbsp;Call_Number</a></label>&nbsp;
                                        <label title="Click here to add author first three letters" className="barcodeParameter" ><a id="add-button" onClick={(e) => this.addParameter(e, '{Author_Three_Letters}')} >&nbsp;&nbsp;Author_Three_Letters</a></label>&nbsp;
                                        <label title="Click here to add author full name" className="barcodeParameter" ><a id="add-button" onClick={(e) => this.addParameter(e, '{Author_Full_Name}')} >&nbsp;&nbsp;Author_Full_Name</a></label>&nbsp;
                                        <label title="Click here to add title last three letters" className="barcodeParameter" ><a id="add-button" onClick={(e) => this.addParameter(e, '{Title_Last_Three_Letters}')} >&nbsp;&nbsp;Title_Last_Three_Letters</a></label>&nbsp;
                                        <label title="Click here to add location" className="barcodeParameter" ><a id="add-button" onClick={(e) => this.addParameter(e, '{Location}')} >&nbsp;&nbsp;Location</a></label>&nbsp;
                                        <label title="Click here to add accession series with number" className="barcodeParameter" ><a id="add-button" onClick={(e) => this.addParameter(e, '{Accession_Series_With_Number}')} >&nbsp;&nbsp;Accession_Series_With_Number</a></label>
                                    </div>
                                </div>

                                <div class="col-md-12 barcodeInfo" style={{ marginTop: 10, padding: 0 }}>
                                    <p style={{ fontWeight: 'bold' }}>How to customize barcode?</p>
                                    <ul style={{ paddingLeft: 20 }}>
                                        <li>To have barcode, add {`{Barcode}`} parameter in above text area.</li>
                                        <li>To have accession series in barcode, add {`{Accession_series}`} parameter in above text area.</li>
                                        <li>To have accession number in barcode, add {`{Accession_number}`} parameter in above text area.</li>
                                        <li>To have call index in barcode, add {`{Call_Index}`} parameter in above text area.</li>
                                        <li>To have call number in barcode, add {`{Call_Number}`} parameter in above text area.</li>
                                        <li>To add your institute name or any other text, add the text in above text area at the appropriate position.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer successFooter">
                            {
                                this.state.disableButton &&
                                <ButtonLoader />
                            }
                            <button className="btn primary-button" onClick={() => this.validateTemplateDetails()} disabled={this.state.disableButton}>{this.state.isTemplateEditMode ? 'Update Template' : 'Add Template'}</button>
                            <button className="btn outline-button" onClick={() => this.closeAddTemplate()}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // METHOD TO GET TEMPLATE NAME
    getTemplateName = (e) => {
        this.setState({
            templateName: e.target.value
        });

        if (e.target.value.length == 0) {
            this.setState({
                templateNameWarning: 'Template name cannot be empty.'
            });
        } else {
            this.setState({
                templateNameWarning: ''
            });
        }
    }

    // METHOD TO GET BARCODE STICKER CUSTOM HEIGHT
    getCustomHeight = (e) => {
        this.setState({
            customHeight: e.target.value
        });

        if (e.target.value.length == 0) {
            this.setState({
                customHeightWarning: 'Barcode height cannot be empty.'
            });
        } else {
            this.setState({
                customHeightWarning: ''
            });
        }
    }

    // METHOD TO GET BARCODE STICKER CUSTOM WIDTH
    getCustomWidth = (e) => {
        this.setState({
            customWidth: e.target.value
        });

        if (e.target.value.length == 0) {
            this.setState({
                customWidthWarning: 'Barcode width cannot be empty.'
            });
        } else {
            this.setState({
                customWidthWarning: ''
            });
        }
    }

    // METHOD TO GET BARCODE CUSTOM HEIGHT
    getBarcodeHeight = (e) => {
        this.setState({
            barcodeHeight: e.target.value
        });

        if (e.target.value.length == 0) {
            this.setState({
                customHeightWarning: 'Barcode height cannot be empty.'
            });
        } else {
            this.setState({
                customHeightWarning: ''
            });
        }
    }

    // METHOD TO GET BARCODE CUSTOM WIDTH
    getBarcodeWidth = (e) => {
        this.setState({
            barcodeWidth: e.target.value
        });

        if (e.target.value.length == 0) {
            this.setState({
                customWidthWarning: 'Barcode width cannot be empty.'
            });
        } else {
            this.setState({
                customWidthWarning: ''
            });
        }
    }

    // METHOD TO BARCODE CONFIGURATION
    getBarcodeConfiguration = (e) => {
        let configurationObject = this.state.configurationObject;
        configurationObject['barcodeConfiguration'] = e;
        // let comment = this.stripHtml(e.editor.getData());

        this.setState({
            configurationObject
        });
    }

    //METHOD TO ADD PARAMETER
    addParameter = (e, parameter) => {
        let configurationObject = this.state.configurationObject;

        if (configurationObject['barcodeConfiguration'] == undefined) {
            configurationObject['barcodeConfiguration'] = "";
        }

        configurationObject['barcodeConfiguration'] += " " + parameter;

        this.setState({
            configurationObject
        });
    }

    // METHOD TO CLOSE ADD FORM MODAL
    closeAddTemplate = () => {
        this.setState({
            addTemplate: false,
            isTemplateEditMode: false,
            templateName: '',
            configurationObject: {},
            customHeight: '',
            customWidth: '',
            barcodeHeight: '',
            barcodeWidth: '',
            horizontalGap: '',
            verticalGap: '',
            pageWidth: '',
            pageHeight: '',
            templateNameWarning: '',
            customHeightWarning: '',
            customWidthWarning: '',
        });
    }

    //METHOD TO OPEN EDIT MODAL
    openEditTemplate = (templateId) => {

        const editAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['print barcode'].find(access => access === 'edit');

        if (editAccess !== undefined) {
            let templateList = this.state.templateList;
            let templateData = templateList[templateId];

            this.setState({
                addTemplate: true,
                isTemplateEditMode: true,
                templateName: templateData.templateName,
                configurationObject: templateData.configuration,
                customHeight: templateData.configuration.height,
                customWidth: templateData.configuration.width,
                barcodeWidth: templateData.configuration.barcodeWidth != undefined ? templateData.configuration.barcodeWidth : '',
                barcodeHeight: templateData.configuration.barcodeHeight != undefined ? templateData.configuration.barcodeHeight : '',
                horizontalGap: templateData.configuration.horizontalGap != undefined ? templateData.configuration.horizontalGap : '',
                verticalGap: templateData.configuration.verticalGap != undefined ? templateData.configuration.verticalGap : '',
                pageHeight: templateData.configuration.pageHeight != undefined ? templateData.configuration.pageHeight : '',
                pageWidth: templateData.configuration.pageWidth != undefined ? templateData.configuration.pageWidth : '',
            });
        }
        else {
            this.setState({
                successModal: true,
                successModalType: 'warning',
                successMessage: 'This operation is restricted by the Library admin.'
            });
        }
    }

    // METHOD TO CHECK ACCESS FOR DELETE OPERATION
    checkDeleteAccess = () => {

        const deleteAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['print barcode'].find(access => access === 'delete');

        if (deleteAccess !== undefined) {
            this.setState({
                deleteModal: true,
            });
        }
        else {
            this.setState({
                successModal: true,
                successModalType: 'warning',
                successMessage: 'This operation is restricted by the Library admin.'
            });
        }
    }

    // METHOD TO CHECK ACCESS FOR ADD OPERATION
    checkAddAccess = () => {
        const addAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['print barcode'].find(access => access === 'add');

        if (addAccess !== undefined) {
            this.setState({
                addTemplate: true
            });
        }
        else {
            this.setState({
                successModal: true,
                successModalType: 'warning',
                successMessage: 'This operation is restricted by the Library admin.'
            });
        }

    }


    // METHOD TO DELETE TEMPLATE
    deleteTemplate = async () => {
        let requestData = {
            "institute_id": config.institute_id,
            "template_id": this.state.templateId,
            "facultyId": config.faculty_id
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'deleteBarcodeTemplate',
            requestData,
            apiPath
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.deleteTemplate()
            }, 1000);
        } else {
            this.closeDeleteModal();
            if (jsonResponse.success) {

                let apiResult = jsonResponse.APIResult;
                let templateList = this.state.templateList;

                if (apiResult.status == "success") {
                    delete templateList[this.state.templateId];
                    this.setState({
                        successModal: true,
                        successModalType: 'success',
                        successMessage: apiResult.message,
                        templateList
                    });
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message
                    });
                }
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while deleting template data. Please try again later.'
                });
            }
        }
    }

    // CLOSE DELETE TEMPLATE MODAL
    closeDeleteModal = () => {
        this.setState({
            deleteModal: false
        });
    }

    // METHOD TO UPDATE PAGINATION COUNT
    updatePaginationCount = (pageNumber) => {
        this.setState({
            pageIndex: pageNumber,
            offset: (pageNumber - 1) * this.state.limit
        }, () => {
            this.apiCallToGetResponseDetails();
        });
    }

    // METHOD TO CLOSE SUCCESS MODAL
    closeSuccessModal = () => {
        this.setState({
            successModal: false
        });
    }

    openActivitySlider = (id) => {
        this.setState({
            selectedIid: id,
            showActivitySlider: true
        });
    };

    closeActivitySlider = () => {
        this.setState({
            selectedIid: "",
            showActivitySlider: false
        });
    };

    render() {
        return (
            <>
                <div className="libraryComponents">
                    <div className="applicationResponse-header" style={{ display: 'flex' }}>
                        <div className="formField-title col-md-9">
                            <button className="btn closeDetails-button" title="Click to print barcode" onClick={() => this.props.closeTemplateManagement()} >
                                <FontAwesomeIcon className="viewGrievance-icon" color="#FFFFFF" icon={['fas', 'arrow-left']} />
                            </button>
                            <h5>Barcode Template Management</h5>
                        </div>
                        <div className="col-md-3 add-button">
                            <button className="btn outline-button" title="Click to add form" onClick={() => this.checkAddAccess()}>
                                <FontAwesomeIcon icon={['fas', 'plus']} size="lg" style={{ marginRight: 5 }} />
                                Add Barcode Template
                            </button>
                        </div>
                    </div>
                    <div className="barcodeTemplateContainer col-md-12">
                        <div className="forms-Table">
                            <table className="table formTableDetails table-responsive-sm jumbotron">
                                <thead>
                                    <tr>
                                        <th style={{ padding: 7 }}>Sr. No.</th>
                                        <th style={{ padding: 7 }}>Template Name</th>
                                        <th style={{ padding: 7 }}>Size per Barcode (width x height)</th>
                                        <th style={{ padding: 7 }}>Last Modified By</th>
                                        <th style={{ padding: 7 }}>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.state.templateListFetching ?
                                            <tr>
                                                <td colSpan="4" style={{ padding: 7 }}>
                                                    <ButtonLoader />
                                                </td>
                                            </tr>
                                            :
                                            Object.keys(this.state.templateList).length > 0 ?
                                                Object.keys(this.state.templateList).map((templateId, index) => {
                                                    let templateData = this.state.templateList[templateId];
                                                    return (
                                                        <tr key={templateId}>
                                                            <td style={{ padding: 7 }}>{this.state.offset + index + 1}.</td>
                                                            <td style={{ padding: 7 }}>{templateData.templateName}</td>
                                                            <td style={{ padding: 7 }}>{templateData.configuration['width'] + "mm x " + templateData.configuration['height'] + "mm"}</td>
                                                            <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF', padding: "5px", cursor: "pointer", color: templateId == this.state.hoverID ? "#0465AC" : "" }}
                                                                onMouseEnter={() => this.setState({ hoverID: templateId })}
                                                                onMouseLeave={() => this.setState({ hoverID: "" })}
                                                                onClick={() => this.openActivitySlider(templateId)}>
                                                                {templateData.updated_by_Name ? (
                                                                    <div className="d-flex flex-column">
                                                                        <div>{templateData.updated_by_Name} ({templateData.last_updated_by_ERP}) | {templateData.updatedOn}</div>
                                                                    </div>
                                                                ) : (
                                                                    <div className="d-flex flex-column">
                                                                        <div>{templateData.added_by_name} ({templateData.added_by_ERP}) | {templateData.addedOn}</div>
                                                                    </div>
                                                                )}
                                                            </td>
                                                            <td style={{ padding: 7 }}>
                                                                <FontAwesomeIcon icon={['fas', 'edit']} style={{ cursor: 'pointer', marginRight: 5 }} size="lg" color="#0465ac" onClick={() => this.setState({ templateId: templateId }, () => this.openEditTemplate(templateId))} />
                                                                <FontAwesomeIcon icon={['fas', 'trash']} style={{ cursor: 'pointer' }} size="lg" color="#0465ac" onClick={() => this.setState({ templateId: templateId }, () => this.checkDeleteAccess())} />
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                                :
                                                <tr>
                                                    <td colSpan="4">Template data not available. Please click on 'Add Barcode Template' to add the template.</td>
                                                </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    {
                        this.state.successModal &&
                        <SuccessModal
                            successModal={this.state.successModal}
                            successModalType={this.state.successModalType}
                            successMessage={this.state.successMessage}
                            closeSuccessModal={this.closeSuccessModal}
                        />
                    }
                    {
                        this.state.deleteModal &&
                        <DeleteModal
                            showModal={this.state.deleteModal}
                            visibility={this.closeDeleteModal}
                            deleteKey='Template'
                            deleteComponent={this.deleteTemplate}
                        />
                    }
                    {
                        this.returnAddTemplateModal()
                    }
                    {
                        this.state.showActivitySlider && this.state.selectedIid != "" &&
                        <SpecificUserLog
                            showSlider={this.state.showActivitySlider}
                            closeSlider={this.closeActivitySlider}
                            logUid={this.state.selectedIid}
                            activityArr={["template_added", "template_updated", "template_deleted"]}
                        />
                    }
                </div>
            </>
        );
    }
}

const mapStateToProps = store => {
    return {
        // VARIABLES TO GET AGENCY DETAILS
        accessibleOperations: store.RouteMenuReducer.accessibleOperations,
        isAdmin: store.RouteMenuReducer.isLibraryAdmin
    };
};

export default connect(mapStateToProps)(ManageTemplate);
